import React, { useEffect, useState } from 'react'
import './nav.css'
import logo from '../../assets/imgs/logo/logo.jpg'
import { styled, alpha } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import {Link, useNavigate} from "react-router-dom" 

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
}));

export default function Navbar() {
  const navigate = useNavigate()
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const id = open ? 'simple-popover' : undefined;


  const [active, setActive] = useState('/')

  const menuOptions = [
    {
      option:'HOME',
      link:'/'
    },
    {
      option:'PRODUCTS',
      link:'/products'
    },
    {
      option:'ABOUT',
      link:'/about'
    },
    {
      option:'SUPPORT',
      link:'/support'
    },
    {
      option:'BLOGS',
      link:'/blogs'
    },
  ]
  const [menuState,setMenu] = useState(false)
  return (
    <>
      <div className="mob-nav">
        <div className="close-mob-nav" onClick={()=>{
          document.getElementsByClassName('mob-nav')[0].style.animation = 'nav-out 0.17s ease-out 1 normal forwards'
        }}>
        <i class="fa-solid fa-xmark"></i>
        </div>
        <div className="page" style={{color:'white'}}>HOME</div>
        <div className="page"><Link to='/products'>PRODUCTS</Link></div>
        <div className="page">ABOUT</div>
        <div className="page">BLOGS</div>
        <div className="page">SERVICES</div>
        <div className="btn1"><button>Download App</button></div>
        <div className="btn2"><button>Login</button></div>
      </div>
      <div className="nav" style={{
        padding:'2vh 1vw',
        backgroundColor:'#f7f7f7'
      }}>
            <div className="logo">
              <img src={logo} alt="" />
            </div>
            <div className="ham" onClick={()=>{
              document.getElementsByClassName('mob-nav')[0].style.animation = 'nav-in 0.17s ease-out 1 normal forwards'
            }}>
              <i class="fa-solid fa-bars"></i>
            </div>
            <div className="nav-items">
              <div className="page" ><Link to='/'>HOME</Link></div>
              <div className="page"><Link to='/products'>PRODUCTS</Link></div>
              <div className="page"><Link to='/about'>ABOUT</Link></div>
              <div className="page"><Link to='/blog'>BLOGS</Link></div>
              <div className="page"><Link to='/support'>FAQ</Link></div>
              <div className="page"><Link to='/contact'>SUPPORT</Link></div>
              <div className="btn1"><button style={{
                color: 'black'
              }}>Download App</button></div>
              <div className="btn2"><button>Login</button></div>
            </div>
          </div>
    </>
  )
}
